import { defineStore } from 'pinia';
import { ref } from 'vue';
import OpportunityStatusesAPI from '@/api/OpportunityStatuses';
import type { OpportunityStatus } from '@/types/OpportunityStatus';

export const useOpportunityStatusesStore = defineStore('OpportunityStatuses', () => {
  const opportunityStatuses = ref<OpportunityStatus[]>([]);
  const opportunityStatuses_result = ref<OpportunityStatus[]>([]);
  
  const fetchOpportunityStatuses = async (params: any): Promise<{ data: OpportunityStatus[]; total: number }> => {
    try {
      
      const response = await OpportunityStatusesAPI.getOpportunityStatuses(params);
      const data: OpportunityStatus[] = response.data.data;
      const total = data.length;
      opportunityStatuses.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching opportunity status listings:', error);
      throw error;
    }
  };

  const fetchOpportunityStatusById = async (id: number) => {
    try {
      const response = await OpportunityStatusesAPI.getOpportunityStatusById(id);
      return response.data.data as OpportunityStatus;
    } catch (error) {
      console.error(`Error fetching opportunity status listing with ID ${id}:`, error);
    }
  };

  const createOpportunityStatus = async (opportunityStatusData: Partial<OpportunityStatus>) => {
    try {
      const response = await OpportunityStatusesAPI.createOpportunityStatus(opportunityStatusData);
      opportunityStatuses.value.push(response.data.data as OpportunityStatus);
      return response.data;
    } catch (error) {
      console.error('Error creating opportunity status listing:', error);
    }
  };

  const updateOpportunityStatus = async (id: number, opportunityStatusData: Partial<OpportunityStatus>) => {
    try {
      const response = await OpportunityStatusesAPI.updateOpportunityStatus(id, opportunityStatusData);
      const updated = response.data.data as OpportunityStatus;
      const index = opportunityStatuses.value.findIndex((listing) => listing.id === id);
      if (index !== -1) {
        opportunityStatuses.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating opportunity status listing with ID ${id}:`, error);
    }
  };

  const deleteOpportunityStatus = async (id: number) => {
    try {
      await OpportunityStatusesAPI.deleteOpportunityStatus(id);
      opportunityStatuses.value = opportunityStatuses.value.filter((listing) => listing.id !== id);
    } catch (error) {
      console.error(`Error deleting opportunity status listing with ID ${id}:`, error);
    }
  };

  const searchOpportunityStatuses = async (params: any): Promise<{ data: OpportunityStatus[]}> => {
    try {
      const response = await OpportunityStatusesAPI.getOpportunityStatuses(params);
      const data: OpportunityStatus[] = response.data.data;
      opportunityStatuses_result.value = data
      return { data };
    } catch (error) {
      console.error('Error fetching user s:', error);
      throw error;
    }
  };

  return {
    opportunityStatuses,
    opportunityStatuses_result,
    fetchOpportunityStatuses,
    fetchOpportunityStatusById,
    createOpportunityStatus,
    updateOpportunityStatus,
    deleteOpportunityStatus,
    searchOpportunityStatuses
  };
});
